var rich_content_viewer_default = {
  "fontElementMap": "AVpSi",
  "wrapper": "sKodM",
  "pluginContainerMobile": "PfZS-",
  "viewer": "mtBxr",
  "android": "UVDEy",
  "rootedTraversedContent": "_0Vty8",
  "atomic": "AoENj",
  "toolbar": "Ucw9p",
  "block": "SUgVS"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
